import React from 'react';

import { Alert, Button, Text } from '@components/common';

export const CreateStudyNoTeamAlert: React.FC = () => (
  <Alert type='error' className='mb-6'>
    <div className='flex items-start'>
      <div>
        <Text bold mb='2'>
          You must be on at least 1 team to create a study
        </Text>
        <Text h='400' mb='2'>
          Please View Teams to join an existing team or create a new one.
        </Text>
        <Button small className='h400' icon='externalLink' target='_blank' href='/teams'>
          View Teams
        </Button>
      </div>
    </div>
  </Alert>
);
